module.exports = __webpack_public_path__ + "img/q-1-2@2x.b8dd6480.png";